import axios from "axios";
import Cookies from "universal-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

const cookies = new Cookies();

export const uploadExcelFile = async (formData) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${apiUrl}/BankStatement/Upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getBankStatementApi = async (url: string, Id: string) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/BankStatement/GetById?id=${Id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getBsByIdApi = async (url: string, Id: string) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(
      `${url}/BankStatement/GetBsById?id=${Id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllBankStatementApi = async (
  url: string,
  {
    year = "",
    month = "",
    bankId = "",
    searchTerm = "",
    pageNumber = 1,
    pageSize = 10,
    isAssigned = undefined, 
    crDr = "", 
  }: {
    year?: string;
    month?: string;
    bankId?: string;
    searchTerm?: string;
    pageNumber?: number;
    pageSize?: number;
    isAssigned?: boolean;
    crDr?: string; 
  } = {}
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(`${url}/BankStatement/getall`, {
      params: {
        year,
        month,
        bankId,
        searchTerm,
        pageNumber,
        pageSize,
        isAssigned, 
        crDr, 
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addBankStatementApi = async (
  BankId: string,
  TransactionId: string | null,
  ValueDate: string,
  ChequeNo: string,
  Description: string,
  CR_DR: string,
  TransactionAmount: string,
  Balance: string
): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.post(
      `${apiUrl}/BankStatement/create`,
      {
        BankId,
        TransactionId,
        ValueDate,
        ChequeNo,
        Description,
        CR_DR,
        TransactionAmount,
        Balance,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateBankStatementApi = async (
  Id: string,
  BankId: string,
  ValueDate: string,
  ChequeNo: string,
  Description: string,
  CR_DR: string,
  TransactionAmount: string,
  Balance: string
): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.post(
      `${apiUrl}/bankstatement/update`,
      {
        Id,
        BankId,
        ValueDate,
        ChequeNo,
        Description,
        CR_DR,
        TransactionAmount,
        Balance,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDonationByBankStatement = async (Id: string, amount: number) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(
      `${apiUrl}/bankstatement/GetDonationsByBankStatement/${Id}?amount=${amount}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getExpenseByBankStatement = async (Id: string, amount: number) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(
      `${apiUrl}/bankstatement/GetExpensesByBankStatement/${Id}?amount=${amount}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBalanceTranferByBankStatement = async (
  TransferFromBankStatementId: string | null,
  TransferToBankStatementId: string,
  amount: number
) => {
  const token = cookies.get("authToken");
  return axios.get(`${apiUrl}/bankstatement/getbalancetransferbybankstatement`, {
    headers: { Authorization: `Bearer ${token}` },
    params: {
      TransferFromBankStatementId,
      TransferToBankStatementId,
      amount
    }
  }).then(res => res.data);
};



export const updateBankST_Donation = async (
  BankStatementId: string,
  DonationId: string,
  TransactionType: string,
  TransactionTypeId: string
) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.post(
      `${apiUrl}/bankstatement/UpdateTransaction`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchUserByIdApi = async (userId: string): Promise<any> => {
  const cookies = new Cookies();
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(`${apiUrl}/login/getuserbyid/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching user by ID:", error);
    return false;
  }
};
